import { RelatedProductExcludedConfig } from '../../infrastructure/state/related-products.state';

import { ItemPublicModels } from '@features/products/item';
import { MediasPublicModels } from '@features/products/medias';

export type RelatedProductType = 'cart_yoda' | 'completeLook' | 'completatulook_yoda' | 'floren' | 'frecuently_bought_together' |
'other_you_may_like' | 'recentlyViewed' | 'recommended_for_you' | 'similar' | 'similares_yoda' | 'top_sales' | 'wishlist';

export type RelatedsProvider = 'YODA' | 'tinybird' | 'wideyes' | 'inditex';

export interface ProductUid {
    arrColorId?: string[];
    colorId?: string;
    mocaId?: string;
    modelName?: string;
    modelVersion?: string;
    product_id: string;
    provider?: RelatedsProvider;
    relatedType?: RelatedProductType;
    uid: string;
}

export interface Item {
    type: RelatedProductType;
    max: number;
    campaign?: string;
    excluded?: RelatedProductExcludedConfig;
}

export enum RelatedsStyleVariation {
    grid = 'grid',
    carrusel = 'carrusel',
}

export interface RelatedProduct {
    title_key: string;
    visible: boolean;
    items: ItemPublicModels.PublicItem[];
    view: RelatedsStyleVariation;
    imageType: MediasPublicModels.PublicMediaClazzType;
}

export interface RelatedProductMapItem {
    id: string;
    relatedType: RelatedProductType;
}

export interface RelatedProducts {
    place: string;
    related_products: RelatedProduct[];
    imageType: MediasPublicModels.PublicMediaClazzType;
}

// Candidad de productos a cargar de una vez. Incluír diferentes miembros para swipers, grids, etc.
export enum RelatedsPageProductsLoad {
    carrusel = 7,
    grid = 12,
}

export interface RelatedsCarousels {
    relatedProduct: RelatedProduct[];
    imageType: MediasPublicModels.PublicMediaClazzType;
}
